import { z } from "zod";
import { MAX_LOGO_DATA_URL_LENGTH } from "./radiology";

/** Alinhado com enum OrganizationType do Prisma. */
export const organizationTypeSchema = z.enum([
  "DENTAL_OFFICE",
  "DENTAL_LAB",
  "RADIOLOGY_CENTER",
]);

export type OrganizationType = z.infer<typeof organizationTypeSchema>;

/** Editor de tipo em Configurações — pode ficar vazio (organização sem tipo definido ainda). */
export const updateOrganizationTypesSchema = z.object({
  types: z.array(organizationTypeSchema).max(3, "Maximo de 3 perfis"),
});

export type UpdateOrganizationTypesInput = z.infer<typeof updateOrganizationTypesSchema>;

/** Renomear organização de equipe em Configurações — a pessoal não passa por aqui (ver rota). */
export const updateOrganizationNameSchema = z.object({
  name: z.string().trim().min(2, "Nome muito curto").max(120, "Nome muito longo"),
});

export type UpdateOrganizationNameInput = z.infer<typeof updateOrganizationNameSchema>;

/** Logo da organização (base64) — o mesmo limite do logo do laboratório; `null` remove. */
export const updateOrganizationLogoSchema = z.object({
  logoUrl: z
    .string()
    .startsWith("data:image/")
    .max(MAX_LOGO_DATA_URL_LENGTH, "Imagem muito grande (máx. ~500 KB)")
    .nullable(),
});
